<fini-header *ngIf="loggedInPage$ | async"></fini-header>
<fini-nav-menu
  *ngIf="(loggedInPage$ | async) && ('hasServers' | state | async)"
></fini-nav-menu>
<fini-banners></fini-banners>
<div
  class="container-xl page-content page-{{ currentRoute$ | async }}"
  [class.login-page]="!(loggedInPage$ | async)"
>
  <div class="server-notifications">
    <fini-notification
      *ngFor="let noti of notifications"
      [message]="noti.message"
      [type]="noti.type"
    ></fini-notification>
  </div>
  <router-outlet
    *ngIf="(guard.loading$ | async) === false; else loading"
  ></router-outlet>
</div>
<ng-container teleportOutlet="modals"></ng-container>
<ng-template #loading>
  <div class="loading mt-5 text-center" *ngIf="guard.loading$ | async">
    <div class="spinner-border"></div>
  </div>
</ng-template>
<fini-helpme-info></fini-helpme-info>
@if (loggedInPage$ | async) {
  <fini-security-check />
  <fini-guides />
  <fini-hovercard-outlet></fini-hovercard-outlet>
  <!--<fini-release-notes></fini-release-notes>-->
  @if (!localhost) {
    <fini-onboarding />
  }
}
@if (false && !NO_SNOW) {
  <Snowf
    [amount]="50"
    [size]="5"
    [speed]="1.5"
    [wind]="0"
    [color]="'#fff'"
    [opacity]="0.8"
    [swing]="1"
    [image]=""
    [zIndex]="999999"
  />
}

@if (demoModeEnabled()) {
  <fini-demo-overlay-chip></fini-demo-overlay-chip>
}
